import {
	AudioFiles,
	DataFiles,
	FileTypeToDisplay,
	FilesKeyForUiRefresh,
	ImageFiles,
} from "../../state/fileState";

import { measures } from "@quickpoint.me/shared";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import AiImageView from "../ai/AiImageView";
import SearchImageView from "../search/SearchImageView";
import DataFileView from "./DataFileView";
import ImageFileView from "./ImageFileView";
import Nav from "./Nav";

export const StyledFiles = styled.div<{ $isInPortrait: boolean }>`
    display: grid;
    height: 100%;
    position: relative; /* anchors the image-search full-panel overlay */
    overflow: hidden; /* the files area scrolls, not the whole panel */
    /* floors keep the 48px header pills, tabs and drop zone breathing */
    grid-template-rows: max(11%, 68px) max(12.5%, 60px) ${(props) =>
			props.$isInPortrait ? "max(10%, 60px)" : "max(17%, 64px)"} 1fr;
    grid-template-columns: 1fr;
    grid-template-areas:
        "title"
        "tabs"
        "browse"
        "files";
    .title {
        grid-area: title;
    };

`;

const StyledImageFilesView = styled.div<{ $isInPortrait: boolean }>`
    display: grid;
    grid-area: files;
    grid-template-columns: ${(props) => (props.$isInPortrait ? "repeat(3, 1fr)" : "repeat(7, 1fr)")};
    grid-auto-rows: min-content;
    /* start, not stretch: the aspect-ratio tiles must take their width from
       the column track, otherwise they size to the row height and overflow
       the panel horizontally */
    align-items: start;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    padding-inline: ${(props) =>
			props.$isInPortrait
				? measures.dialogPanel.portrait.margin
				: measures.dialogPanel.landscape.margin};

`;

const StyledDataFilesView = styled.div<{ $isInPortrait: boolean }>`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    min-height: 0;
    border: 1px solid ${(props) => props.theme.navigationFrame};
    margin: ${(props) =>
			props.$isInPortrait
				? measures.dialogPanel.portrait.margin
				: measures.dialogPanel.landscape.margin};

`;

function FilesView({ $isInPortrait }: { $isInPortrait: boolean }) {
	const dataFiles = useRecoilValue(DataFiles)?.map((file, idx) => (
		<DataFileView
			key={file.id}
			file={file}
			$idx={idx}
			$isInPortrait={$isInPortrait}
		/>
	));

	const audioFiles = useRecoilValue(AudioFiles)?.map((file, idx) => (
		<DataFileView
			key={file.id}
			file={file}
			$idx={idx}
			$isInPortrait={$isInPortrait}
		/>
	));

	const imageFiles = useRecoilValue(ImageFiles)?.map((file) => (
		<ImageFileView key={file.id} file={file} />
	));
	// const hideTitle = useRecoilValue(UnprocessedFilesPresent);
	const filesKeyForUiRefresh = useRecoilValue(FilesKeyForUiRefresh);
	const fileTypeToDisplay = useRecoilValue(FileTypeToDisplay);

	return (
		<StyledFiles $isInPortrait={$isInPortrait} id="styled-files">
			<Nav $isInPortrait={$isInPortrait} />
			{fileTypeToDisplay === "image" && (
				<StyledImageFilesView
					key={filesKeyForUiRefresh}
					$isInPortrait={$isInPortrait}
					className="file-drop-zone"
				>
					{imageFiles}
				</StyledImageFilesView>
			)}
			{fileTypeToDisplay === "audio" && (
				<StyledDataFilesView
					key={filesKeyForUiRefresh}
					$isInPortrait={$isInPortrait}
					className="file-drop-zone"
				>
					{audioFiles}
				</StyledDataFilesView>
			)}
			{fileTypeToDisplay === "data" && (
				<StyledDataFilesView
					key={filesKeyForUiRefresh}
					$isInPortrait={$isInPortrait}
					className="file-drop-zone"
				>
					{dataFiles}
				</StyledDataFilesView>
			)}
      {fileTypeToDisplay === "ai" && <AiImageView />}
      {fileTypeToDisplay === "search" && <SearchImageView />}
		</StyledFiles>
	);
}

export default FilesView;
